import { render } from "./Bmi.vue?vue&type=template&id=caa24550"
import script from "./Bmi.vue?vue&type=script&lang=js"
export * from "./Bmi.vue?vue&type=script&lang=js"

import "./Bmi.vue?vue&type=style&index=0&id=caa24550&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__